import React, { Component } from 'react';
import './style.css';

let initialStyles = {
    backgroundColor: "#fff"
}

class Spinner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            styles:{
            ...initialStyles,
            ...props.styles
            }
        }
    }
    render() {
        return (
            <div className={"css-spinner " + this.props.className}>
                <div style={this.state.styles} className="rect1"></div>
                <div style={this.state.styles} className="rect2"></div>
                <div style={this.state.styles}  className="rect3"></div>
                <div style={this.state.styles}  className="rect4"></div>
                <div style={this.state.styles}  className="rect5"></div>
            </div>
        );
    }
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Shared/Spinner/index.jsx